export const name: string = 'Filter Toolbar';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-toolbar';
export const icon: string = 'check';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-toolbar-filter';
//export const priority: number = 1;

export const themeFields = {
    section_Buttons: 'toolbar-filter-buttons',
    justifyButtons: 'toolbar-filter-justify-toolbar-buttons',
    showResetButton: 'toolbar-filter-show-reset-button',
    resetButtonShowMode: 'toolbar-filter-reset-button-show-mode',
    showApplyButton: 'toolbar-filter-show-apply-button',
    showRefreshButton: 'toolbar-filter-show-refresh-button',
    refreshButtonShowMode: 'toolbar-filter-refresh-button-show-mode',
    //showCancelButton: 'toolbar-filter-show-cancel-button',
    //cancelButtonShowMode: 'toolbar-filter-cancel-button-show-mode',
    showUndoAndRedoButtons: 'toolbar-filter-show-undo-and-redo-buttons'
};
